import NotificationInterface from "@app/Interface/NotificationInterface";
import htmlParser from "@app/utils/htmlParser";

export default class NotificationModel implements NotificationInterface {
    id: number;
    title: string;
    user: number;
    fpu: number;
    analyte: string;
    dismissed: boolean;
    date: Date;

    constructor (notification?: NotificationInterface) {
        this.id = notification?.id ?? 0;
        this.title = htmlParser.htmlDecode(notification?.title ?? "");
        this.user = notification?.user ?? 0;
        this.fpu = notification?.fpu ?? 0;
        this.analyte = notification?.analyte ?? "";
        this.dismissed = notification?.dismissed ?? false;
        this.date = notification?.date ? new Date(notification.date) : new Date();
    }
    
}